module.exports = __webpack_public_path__ + "static/media/speech-bubble.f9a7a657.png";